import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="sortable"
export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      onEnd: this.end.bind(this)
    })
  }

  csrfToken() {
    const metaTag = document.querySelector('meta[name="csrf-token"]')
    return metaTag ? metaTag.content : ''
  }

  async setItemPosition(url, position) {
    const response = await fetch(url + '?format=json', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken(),
      },
      body: JSON.stringify({ data: { position: position }})
    });
    return response.json();
  }

  end(event){
    let url = event.item.dataset.url
    let position = event.newIndex + 1;
    this.setItemPosition(url, position).then((data) => {
      if(data.item.position == position){
        console.log('new position updated! :-)')
      }
    });
  }

  
}
